import { RefreshAccountCrmResponseSchema } from './refresh-account-crm.schema';
/**
 * Die Stammdaten eines Kontos jetzt aus dem CRM lesen (LIC-26/LIC-29).
 *
 * Es gibt fünf Momente, an denen das ohnehin geschieht — beim Verknüpfen, vor
 * einem Kauf, beim Öffnen des Abrechnungsbereichs, täglich und auf Zuruf des
 * CRM. Dieser hier ist der sechste: jemand sieht auf die Kontoseite und
 * zweifelt. Die Kontaktrollen fallen sonst ganz durch, weil eine geänderte
 * Kontaktzuordnung die **Firma** nicht ändert und der Zuruf ausbleibt.
 */ export const refreshAccountCrmContract = {
    method: 'POST',
    path: '/api/v2/admin/accounts/:accountId/crm-refresh',
    description: 'Read this account’s master data from the CRM now',
    responseSchema: RefreshAccountCrmResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - not a platform administrator',
            404: 'Not Found - no such account'
        }
    }
};

//# sourceMappingURL=refresh-account-crm.contract.js.map